import { render, staticRenderFns } from "./PublisherSettings.vue?vue&type=template&id=4dce0008"
import script from "./PublisherSettings.vue?vue&type=script&lang=js"
export * from "./PublisherSettings.vue?vue&type=script&lang=js"
import style0 from "./PublisherSettings.vue?vue&type=style&index=0&id=4dce0008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports